import { PaneType } from "@unlikelyai-magic/shared/data-access/api";
import { cn } from "@unlikelyai-magic/utils";
import { BlurbNode, BlurbNodeProps } from "./BlurbNode";

export type GroupNodeProps = {
  id: string;
  data: BlurbNodeProps["data"];
};

export const GroupNode = (props: GroupNodeProps) => {
  const isContext = props.data.type === PaneType.CONTEXT;
  return (
    <div
      className={cn(
        "relative h-full rounded-xl border border-blue-400 bg-blue-100/40",
        isContext && "border-gray-200 bg-gray-200/40"
      )}
    >
      {!isContext && (
        <div className="absolute -top-4 left-0 right-0 -translate-y-full px-4">
          <BlurbNode id={props.id} data={props.data} />
        </div>
      )}
    </div>
  );
};
